import { render, staticRenderFns } from "./FeriadosForm.vue?vue&type=template&id=6dbea9dc"
import script from "./FeriadosForm.vue?vue&type=script&lang=js"
export * from "./FeriadosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports